import { h } from 'preact'
import FadingImage from './FadingImage'
import EditButton from './EditButton'

import {IMAGE_URL} from '../main' 

export default ({shade, cable, mount, editShade, editCable}) =>
    <div class="limba__product">
        {mount && <FadingImage src={`${IMAGE_URL}/deckenanbindung/${mount.image}`} /> }
        {cable &&
            <FadingImage src={`${IMAGE_URL}/kabel/${cable.image}`} class="limba__product__cable">
                {editCable && <EditButton onClick={editCable} />}
            </FadingImage>
        }
        {shade && 
            <FadingImage src={`${IMAGE_URL}/leuchtenschirm/${shade.image}`} class="limba__product__shade">
                {editShade && <EditButton onClick={editShade} />}
            </FadingImage>
        }
    </div>



// WEBPACK FOOTER //
// ./js/components/Product.js